
import { TLangObject } from "@brg/api"

export enum ANCHOR_TYPE {
    header = 0,
    popup = 1
}

export type TitleT = {
    text: TLangObject<'Global'>;
    visible: boolean;
    color: string;
}

export type SubtitleT = {
    text: TLangObject<'Global'>;
    visible: boolean;
    color: string;
}

export type ButtonT = {
    text: TLangObject<'Global'>,
    color: string,
    bgColor: string,
    visible: boolean,
    href: string,
}

export type AnchorT = {
    anchorType: ANCHOR_TYPE,
    anchorVisible?: boolean,
}

export interface IAddProjectCoverContent {
    title: TitleT,
    subtitle: SubtitleT,
    button: ButtonT,
    anchors: AnchorT
}
import { TLangObject } from "@brg/api"

export enum ANCHOR_TYPE {
    header = 0,
    popup = 1
}

export type TitleT = {
    text: TLangObject<'Global'>;
    visible: boolean;
    color: string;
}

export type SubtitleT = {
    text: TLangObject<'Global'>;
    visible: boolean;
    color: string;
}

export type ButtonT = {
    text: TLangObject<'Global'>,
    color: string,
    bgColor: string,
    visible: boolean,
    href: string,
}

export type AnchorT = {
    anchorType: ANCHOR_TYPE,
    anchorVisible?: boolean,
}

export interface IAddProjectCoverContent {
    title: TitleT,
    subtitle: SubtitleT,
    button: ButtonT,
    anchors: AnchorT
}